import {cn} from '@rocket-ui/tools';
import React, {ComponentType, FC, ReactElement, SVGProps} from 'react';
import {Icon, IconName} from '../../Icon';

export type IconType = IconName | ReactElement<SVGProps<SVGSVGElement>> | ComponentType<SVGProps<SVGSVGElement>>;

export const ButtonIcon: FC<{icon: IconType; className?: string}> = ({icon, className}) => {
	if (React.isValidElement(icon))
		return React.cloneElement<SVGProps<SVGSVGElement>>(icon, {className: cn(icon.props.className, className)});

	if (typeof icon === 'function') {
		const Icon = icon as ComponentType<SVGProps<SVGSVGElement>>;

		return <Icon className={className} />;
	}

	const iconName = icon as IconName;

	return <Icon name={iconName} className={className} />;
};
